import styled from 'styled-components';

export const ToggleStyled = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
`;

export const ToggleLabelStyled = styled.div`
  font-weight: 700;
  line-height: 1.5em; /* 171.429% */
`;

export const ToggleSwitchStyled = styled.div`
  height: 2.25em;

  position: absolute;
  right: 3em;

  &:has(input:focus) {
    .focus-ring {
      border: 2px solid var(--a11y);
      border-radius: 1.5em;
    }
  }

  svg {
    margin: 0.25em;
  }
  
  .focus-ring {
    position: absolute;
    width: calc(100% + 0.5em);
    height: 2.75em;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
